import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { ITutorialsBlogSection } from "./types";
import { TutorialBlogCard } from "./TutorialBlogCard";

export const TutorialsBlogSection: React.FC<ITutorialsBlogSection> = ({
  title,
  cards,
  ...rest
}) => {
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <Grid
      customStyle={{
        maxWidth: 800,
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "40px 0",
        },
      }}
      id="TutorialsBlogSection"
      {...rest}
    >
      <Heading
        as="h2"
        customStyle={{ [bp.FROM_DESKTOP]: { fontSize: 28, lineHeight: 1.21 } }}
      >
        {title}
      </Heading>
      <div
        className={css({
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          [bp.FROM_DESKTOP]: { flexDirection: "row" },
          nested: {
            "> div:not(:first-of-type)": {
              marginTop: 30,
              [bp.FROM_TABLET]: {
                marginTop: 40,
              },
              [bp.FROM_DESKTOP]: {
                marginTop: 0,
              },
            },
            "> div:last-of-type": {
              [bp.FROM_DESKTOP]: {
                marginRight: 0,
              },
            },
          },
        })}
      >
        {cards.map((element, index) => {
          return <TutorialBlogCard key={`BlogCard-${index}`} {...element} />;
        })}
      </div>
    </Grid>
  );
};
